import { type ReactNode } from 'react';
import { BODY, Bullet, Card, Section, Subsection } from './rules-typography';

function SpeedBonus(): ReactNode {
  return (
    <Subsection title="Bonus de velocidad">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Primero en llegar a 99 en el día →{' '}
          <strong className="text-text-primary">+$9</strong>
        </Bullet>
        <Bullet>
          Primero en llegar a 555 en la semana →{' '}
          <strong className="text-text-primary">+$55</strong>
        </Bullet>
      </ul>
    </Subsection>
  );
}

function TeamBonus(): ReactNode {
  return (
    <Subsection title="Bonus de equipo">
      <p className={BODY}>Solo si se cumple el objetivo global.</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Promedio 33-65 → <strong className="text-text-primary">+$33</strong>
        </Bullet>
        <Bullet>
          Promedio 66-98 → <strong className="text-text-primary">+$66</strong>
        </Bullet>
        <Bullet>
          Promedio 99+ → <strong className="text-text-primary">+$99</strong>
        </Bullet>
      </ul>
      <p className={BODY}>
        Cuantos más jugadores activos, más fácil desbloquearlo. Puedes invitar
        amigos para subir el nivel del equipo.
      </p>
    </Subsection>
  );
}

function TopThree(): ReactNode {
  return (
    <Subsection title="Top 3 semanal">
      <p className={BODY}>Mejores de la semana al cierre del domingo 23:59:</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          1º → <strong className="text-text-primary">$150</strong>
        </Bullet>
        <Bullet>
          2º → <strong className="text-text-primary">$100</strong>
        </Bullet>
        <Bullet>
          3º → <strong className="text-text-primary">$50</strong>
        </Bullet>
      </ul>
    </Subsection>
  );
}

export function WeeklyBonuses(): ReactNode {
  return (
    <Section title="Bonuses semanales">
      <Card>
        <div className="space-y-md">
          <SpeedBonus />
          <TeamBonus />
          <TopThree />
        </div>
      </Card>
    </Section>
  );
}
